import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /**
     * Lights and shadows (render/lighting.ts): figures' ground and cast shadows, the time of day
     * (dusk, night and the pools of lamplight) and the light in rooms. Off: plain daylight, none of it drawn.
     */
    lighting: boolean;
  }
}

defineSetting({
  key: 'lighting',
  default: true,
  order: 100,
  menu: { group: 'visual', label: 'แสงและเงา (เงาตัวละคร แสงกลางวัน/กลางคืน และโคมไฟ)' },
});
